import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./import.module.css";
export const PopupButton = ({ name, onClick }) => {
    return (_jsx("div", Object.assign({ className: styles.popupButton, onClick: () => onClick() }, { children: name })));
};
